import { CountryAssessments } from "@app/features/other/genericApiSlice";
import { countryHasAssessments, getFlagUrl } from "../utils";

type CountryCardProps = {
  country: CountryAssessments;
  handleCountryClick: (country: CountryAssessments) => void;
};

const CountryCard = ({ country, handleCountryClick }: CountryCardProps) => {
  const flag = getFlagUrl(country.iso_code);
  const hasAssessments = countryHasAssessments(country);

  return (
    <button
      type="button"
      className={`country-card ${!hasAssessments ? "country-card-no-assessments" : ""}`}
      onClick={() => hasAssessments && handleCountryClick(country)}
      disabled={!hasAssessments}
      aria-disabled={!hasAssessments}
    >
      <div className="country-card-flag">
        <img src={flag} alt="" />
      </div>
      <div className="country-card-name">{country.name}</div>
    </button>
  );
};

export default CountryCard;
